import { useState, useEffect } from "react";
import { collection, getDocs, doc, addDoc, setDoc, updateDoc, deleteDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../../firebase/config";

const G={bg:"#FAF9F7",s1:"#FFFFFF",s2:"#F4F2EF",border:"#E2DFD9",border2:"#D4D0CA",black:"#1C1917",off:"#3D3830",muted:"#8C8078",orange:"#D2611A",green:"#16A34A",red:"#DC2626",blue:"#2563EB",sans:"'Outfit','Helvetica Neue',Arial,sans-serif",mono:"'IBM Plex Mono',monospace"};
const O="#D2611A",BK="#1C1917";

function ModalProveedor({prov,onGuardar,onClose}){
  const[form,setForm]=useState(prov?{...prov}:{nombre:"",contacto:"",wechat:"",email:"",pais:"China",ciudad:"Guangzhou",notas:"",activo:true});
  const[saving,setSaving]=useState(false);
  const inp={width:"100%",background:"transparent",border:"none",borderBottom:`1.5px solid ${G.border2}`,color:G.black,fontFamily:G.sans,fontSize:13,padding:"7px 0",outline:"none"};
  const lbl={fontFamily:G.sans,fontSize:9,letterSpacing:2,textTransform:"uppercase",color:G.muted,marginBottom:5,fontWeight:600,display:"block"};

  const guardar=async()=>{
    if(!form.nombre.trim())return;
    setSaving(true);
    try {
      const data={...form,updatedAt:serverTimestamp()};
      if(prov?.id){
        // Editar existente
        await updateDoc(doc(db,"proveedores",prov.id),data);
      } else {
        // Nuevo — Firestore genera el ID
        data.creadoEn=serverTimestamp();
        await addDoc(collection(db,"proveedores"),data);
      }
      setSaving(false);
      onGuardar();
    } catch(e){
      console.error("Error guardando proveedor:",e);
      alert("Error al guardar: "+e.message);
      setSaving(false);
    }
  };

  return(
    <div style={{position:"fixed",inset:0,background:"rgba(28,25,23,.5)",zIndex:300,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
      <div style={{background:G.s1,border:`1.5px solid ${G.border}`,padding:"28px 32px",width:480,maxWidth:"95vw"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:22}}>
          <div style={{fontFamily:G.sans,fontSize:18,color:G.black,fontWeight:700}}>{prov?"Editar proveedor":"Nuevo proveedor"}</div>
          <button onClick={onClose} style={{background:"none",border:"none",fontSize:20,color:G.muted,cursor:"pointer"}}>×</button>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14,marginBottom:14}}>
          <div style={{gridColumn:"1/-1"}}>
            <label style={lbl}>Nombre del proveedor *</label>
            <input value={form.nombre} onChange={e=>setForm(p=>({...p,nombre:e.target.value}))} placeholder="Ej: Guangdong Ceramic Co." style={inp}/>
          </div>
          <div>
            <label style={lbl}>Contacto / Persona</label>
            <input value={form.contacto||""} onChange={e=>setForm(p=>({...p,contacto:e.target.value}))} placeholder="Mr. Li" style={inp}/>
          </div>
          <div>
            <label style={lbl}>WeChat / WhatsApp</label>
            <input value={form.wechat||""} onChange={e=>setForm(p=>({...p,wechat:e.target.value}))} placeholder="@proveedor" style={inp}/>
          </div>
          <div>
            <label style={lbl}>Email</label>
            <input value={form.email||""} onChange={e=>setForm(p=>({...p,email:e.target.value}))} placeholder="factory@email.com" style={inp}/>
          </div>
          <div>
            <label style={lbl}>Ciudad</label>
            <input value={form.ciudad||""} onChange={e=>setForm(p=>({...p,ciudad:e.target.value}))} placeholder="Guangzhou" style={inp}/>
          </div>
          <div style={{gridColumn:"1/-1"}}>
            <label style={lbl}>Notas internas</label>
            <input value={form.notas||""} onChange={e=>setForm(p=>({...p,notas:e.target.value}))} placeholder="Plazos, condiciones, observaciones..." style={inp}/>
          </div>
        </div>
        <label style={{display:"flex",alignItems:"center",gap:10,cursor:"pointer",marginBottom:20}}>
          <input type="checkbox" checked={form.activo} onChange={e=>setForm(p=>({...p,activo:e.target.checked}))}/>
          <span style={{fontFamily:G.sans,fontSize:12,color:G.off}}>Proveedor activo</span>
        </label>
        <div style={{display:"flex",gap:10}}>
          <button onClick={guardar} disabled={saving} style={{flex:1,padding:"10px 0",background:O,color:"#fff",fontFamily:G.sans,fontSize:9,letterSpacing:2,textTransform:"uppercase",border:"none",cursor:"pointer",fontWeight:700}}>
            {saving?"Guardando...":"Guardar →"}
          </button>
          <button onClick={onClose} style={{padding:"10px 16px",background:"transparent",color:G.muted,fontFamily:G.sans,fontSize:9,letterSpacing:2,textTransform:"uppercase",border:`1.5px solid ${G.border}`,cursor:"pointer"}}>Cancelar</button>
        </div>
      </div>
    </div>
  );
}

export default function AdminProveedores(){
  const[provs,setProvs]=useState([]);
  const[loading,setLoading]=useState(true);
  const[modal,setModal]=useState(null);

  const cargar=async()=>{
    setLoading(true);
    const snap=await getDocs(collection(db,"proveedores")).catch(()=>({docs:[]}));
    setProvs(snap.docs.map(d=>({id:d.id,...d.data()})));
    setLoading(false);
  };
  useEffect(()=>{cargar();},[]);

  const eliminar=async(p)=>{
    if(!window.confirm(`¿Eliminar "${p.nombre}"?`))return;
    await deleteDoc(doc(db,"proveedores",p.id));
    cargar();
  };

  return(
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
        <div>
          <div style={{fontFamily:G.sans,fontSize:22,color:G.black,fontWeight:700,marginBottom:3}}>Proveedores</div>
          <div style={{fontFamily:G.mono,fontSize:10,color:G.muted}}>{provs.length} proveedores registrados · Solo visible para administradores</div>
        </div>
        <button onClick={()=>setModal("nuevo")} style={{padding:"9px 22px",background:O,color:"#fff",fontFamily:G.sans,fontSize:9,letterSpacing:2,textTransform:"uppercase",border:"none",cursor:"pointer",fontWeight:700}}>
          + Nuevo proveedor
        </button>
      </div>
      <div style={{background:"#EFF6FF",border:"1px solid #2563EB33",padding:"10px 16px",marginBottom:20,fontFamily:G.sans,fontSize:11,color:"#1D4ED8",lineHeight:1.6}}>
        ℹ Los proveedores se asignan a cada producto desde el panel de Productos. Son completamente invisibles para los clientes. Cuando un cliente hace un pedido, el sistema consolida automáticamente los ítems por proveedor.
      </div>

      {loading?(
        <div style={{padding:40,textAlign:"center",fontFamily:G.sans,fontSize:12,color:G.muted}}>Cargando...</div>
      ):(
        <div style={{background:G.border}}>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr 80px 100px",background:G.s2,padding:"8px 14px",gap:8}}>
            {["Proveedor","Contacto","Ciudad","Estado","Acciones"].map(h=>(
              <div key={h} style={{fontFamily:G.sans,fontSize:8,letterSpacing:2,color:G.muted,textTransform:"uppercase",fontWeight:600}}>{h}</div>
            ))}
          </div>
          {provs.length===0?(
            <div style={{background:G.s1,padding:32,textAlign:"center",fontFamily:G.sans,fontSize:12,color:G.muted}}>
              Sin proveedores. Creá el primero con el botón de arriba.
            </div>
          ):provs.map(p=>(
            <div key={p.id} style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr 80px 100px",background:G.s1,padding:"11px 14px",gap:8,borderBottom:`1px solid ${G.border}`,alignItems:"center"}}>
              <div>
                <div style={{fontFamily:G.sans,fontSize:13,color:G.black,fontWeight:600}}>{p.nombre}</div>
                {p.notas&&<div style={{fontFamily:G.sans,fontSize:10,color:G.muted,marginTop:1}}>{p.notas.slice(0,50)}</div>}
              </div>
              <div>
                <div style={{fontFamily:G.sans,fontSize:12,color:G.off}}>{p.contacto||"—"}</div>
                {p.wechat&&<div style={{fontFamily:G.mono,fontSize:9,color:G.muted}}>{p.wechat}</div>}
              </div>
              <div style={{fontFamily:G.sans,fontSize:11,color:G.muted}}>{p.ciudad||"—"}</div>
              <div>
                <span style={{fontFamily:G.mono,fontSize:8,color:p.activo?G.green:G.muted,border:`1px solid ${p.activo?G.green:G.muted}`,padding:"2px 6px",letterSpacing:1,textTransform:"uppercase"}}>
                  {p.activo?"Activo":"Inactivo"}
                </span>
              </div>
              <div style={{display:"flex",gap:8}}>
                <button onClick={()=>setModal(p)} style={{fontFamily:G.mono,fontSize:14,color:G.blue,background:"none",border:"none",cursor:"pointer"}}>✎</button>
                <button onClick={()=>eliminar(p)} style={{fontFamily:G.mono,fontSize:14,color:G.red,background:"none",border:"none",cursor:"pointer"}}>✕</button>
              </div>
            </div>
          ))}
        </div>
      )}
      {modal&&<ModalProveedor prov={modal==="nuevo"?null:modal} onGuardar={()=>{setModal(null);cargar();}} onClose={()=>setModal(null)}/>}
    </div>
  );
}
